// One line per IU Rewrite change on a row (row.iuRewrite from the proxy), e.g.
// "IS_TEST_BUILD: 1 → 0", "removed adtest (was on)", "added restricted_to_buyer_network=1418116".
export function describeRewrite(iuRewrite) {
  const changes = (iuRewrite && Array.isArray(iuRewrite.changes)) ? iuRewrite.changes : [];
  return changes.map((c) => {
    if (!c) return '';
    const s = describeOne(c);
    return c.where === 'body' ? `${s} (in body)` : s;
  }).filter(Boolean);
}

function describeOne(c) {
  if (c.field === 'paramRemove' || c.field === 'kvpRemove') return `removed ${c.key}${c.from != null ? ` (was ${c.from})` : ''}`;
  if (c.field === 'paramAdd' || c.field === 'kvpAdd') return c.from != null ? `${c.key}: ${c.from} → ${c.value}` : `added ${c.key}=${c.value}`;
  if (c.field === 'metaTestMode') return c.from != null ? `${c.key}: ${c.from} → ${c.value} (Meta test mode)` : `added ${c.key}=${c.value} (Meta test mode)`;
  if (c.field === 'metaField') return c.from != null ? `${c.key}: ${c.from} → ${c.to}` : `added ${c.key}=${c.to}`;
  return `${c.field}${c.key ? ` ${c.key}` : ''}: ${c.from ?? ''} → ${c.to ?? c.value ?? ''}`;
}

// One line per change a Chaos "patch" or "swap" rule made to this row's response
// (row.chaos.patched / row.chaos.swapped from the proxy), e.g.
// "placements.0.feature_config.x: \"true\" → \"false\"" or "1143…588 → 9999…111 (×2)".
export function describeChaosPatch(chaos) {
  if (chaos && chaos.action === 'swap' && Array.isArray(chaos.swapped)) {
    return chaos.swapped.filter(Boolean).map((c) => `${c.from} → ${c.to}${c.count > 1 ? ` (×${c.count})` : ''}`);
  }
  const changes = (chaos && chaos.action === 'patch' && Array.isArray(chaos.patched)) ? chaos.patched : [];
  return changes.filter(Boolean).map((c) => `${c.path}: ${JSON.stringify(c.from)} → ${JSON.stringify(c.to)}`);
}
